// Main JS file

// DOM ready
$(function () {

    var $body = $('body'),
        drawerPanels = ['nav', 'login', 'search'],
        $nav = $('.drawer--nav'),
        $navToggle = $('.header [data-toggle]'),
        $footerNavToggle = $('.footer [data-toggle]'),
        $loginToggle = $('.login-toggle'),
        $searchToggle = $('.search-toggle'),
        headerToggleActiveClass = 'active',
        $sideNavToggle = $('.side-nav-toggle'),
        sideNavOpenClass = 'side-nav-open',
        touchDeviceClass = 'is-touch',
        openNavPanelId = ''
    ;

    // Detect touch device
    $(window).on('touchstart', function () {
        $body.addClass(touchDeviceClass);
    });

    // Side nav toggle
    function toggleSideNav(visible) {
        $body.toggleClass(sideNavOpenClass, visible);
    }
    $sideNavToggle.on('click', function(e) {
        toggleSideNav(!$body.hasClass(sideNavOpenClass));
    });

    // Header panel toggle
    function togglePanel(trigger, panel, visible) {
        closeDrawer();

        if ($(trigger).data('content')) {
            var $drawerContents = $('.drawer--' + panel + ' [data-content-id]'),
                $targetContent = $('[data-content-id="' + $(trigger).data('content') + '"]');
        }

        if (visible) {
            // Open
            openNavPanelId = $(trigger).data('content');
            $body.addClass(panel + '-open');
            if ($drawerContents) {
                $drawerContents.hide();
                $targetContent.show();
            }
            setTimeout(function() {
                $('.drawer--' + panel + ' input:first').focus();
            }, 300);
            $(trigger)
                .parent('li')
                .addClass(headerToggleActiveClass);
        } else {
            // Close
            $body.removeClass(panel + '-open');
            $('.drawer--' + panel + ' input:first').blur();
            $(trigger)
                .parent('li')
                .removeClass(headerToggleActiveClass);
        }
    }

    // Close drawer
    function closeDrawer() {
        $.each(drawerPanels, function(i, panel) {
            $body.removeClass(panel + '-open');
            $('.' + panel + '-toggle')
                .parent('li')
                .removeClass(headerToggleActiveClass);
        });
    }

    // Nav toggle
    $navToggle.on('click', function(e) {
        e.preventDefault();
        togglePanel(this, 'nav', !$body.hasClass('nav-open'));
    });
    $navToggle.hover(
        function(e) {
            if (!$body.hasClass(touchDeviceClass)) {
                togglePanel(this, 'nav', true);
            }
        },
        function(e) {
            if (!$body.hasClass(touchDeviceClass)) {
                togglePanel(this, 'nav', false);
            }
        }
    );
    $nav.hover(
        function(e) {
            if (!$body.hasClass(touchDeviceClass)) {
                togglePanel($navToggle.filter('[data-content="' + openNavPanelId + '"]'), 'nav', true);
            }
        },
        function(e) {
            if (!$body.hasClass(touchDeviceClass)) {
                togglePanel($navToggle.filter('[data-content="' + openNavPanelId + '"]'), 'nav', false);
            }
        }
    );

    $footerNavToggle.on('click', function(e) {
        e.preventDefault();
        var clicked = false,
            trigger = this;
        $('html, body').animate({
            scrollTop: 0
        }, 500, function() {
            if (!clicked) {
                togglePanel($navToggle.filter('[data-content="' + $(trigger).data('content') + '"]'), 'nav', true);
                clicked = true;
            }
        });
    });

    // Login toggle
    $loginToggle.on('click', function(e) {
        togglePanel(this, 'login', !$body.hasClass('login-open'));
    });

    // Search toggle
    $searchToggle.on('click', function(e) {
        togglePanel(this, 'search', !$body.hasClass('search-open'));
    });

    // Global Esc press
    $(document).on('keyup', function(e) {
        if (e.keyCode === 27) { // Esc
            closeDrawer();
        }
    });

    // Global click outside menu/search
    $(document).on('click touchend', function(e) {
        if (!$(e.target).closest('.header').length) {
            closeDrawer();
        }
    });

});
